/** The only menu data allowed across the cached layout/client boundary. */
export interface BrowseMenuRootSummary {
  uuid: string;
  display_name: string;
}

const ROOT_ORDER = ["Menswear", "Womenswear", "Kidswear", "Beauty"];

export function projectBrowseMenuRoots(value: unknown): BrowseMenuRootSummary[] {
  if (!Array.isArray(value)) throw new Error("Invalid browse menu roots");
  const roots = value.map((item: unknown) => {
    if (
      !item ||
      typeof item !== "object" ||
      !("uuid" in item) ||
      typeof item.uuid !== "string" ||
      !item.uuid.trim() ||
      !("display_name" in item) ||
      typeof item.display_name !== "string" ||
      !item.display_name.trim()
    )
      throw new Error("Invalid browse menu root");
    return { uuid: item.uuid, display_name: item.display_name };
  });
  if (new Set(roots.map((root) => root.uuid)).size !== roots.length) {
    throw new Error("Duplicate browse menu root");
  }
  const order = (name: string) => {
    const index = ROOT_ORDER.indexOf(name);
    return index < 0 ? ROOT_ORDER.length : index;
  };
  return roots.sort((a, b) => order(a.display_name) - order(b.display_name));
}
